/* tslint:disable */
/* eslint-disable */

import { ReaderFragment } from "relay-runtime";
import { FragmentRefs } from "relay-runtime";
export type PdpSharedContactSupportButton_user = {
    readonly profile: {
        readonly displayName: string | null;
        readonly email: string | null;
    } | null;
    readonly " $refType": "PdpSharedContactSupportButton_user";
};
export type PdpSharedContactSupportButton_user$data = PdpSharedContactSupportButton_user;
export type PdpSharedContactSupportButton_user$key = {
    readonly " $data"?: PdpSharedContactSupportButton_user$data;
    readonly " $fragmentRefs": FragmentRefs<"PdpSharedContactSupportButton_user">;
};



const node: ReaderFragment = {
  "kind": "Fragment",
  "name": "PdpSharedContactSupportButton_user",
  "type": "User",
  "metadata": null,
  "argumentDefinitions": [],
  "selections": [
    {
      "kind": "LinkedField",
      "alias": null,
      "name": "profile",
      "storageKey": null,
      "args": null,
      "concreteType": "Profile",
      "plural": false,
      "selections": [
        {
          "kind": "ScalarField",
          "alias": null,
          "name": "displayName",
          "args": null,
          "storageKey": null
        },
        {
          "kind": "ScalarField",
          "alias": null,
          "name": "email",
          "args": null,
          "storageKey": null
        }
      ]
    }
  ]
};
(node as any).hash = 'df66edc7ccf4b474e5d0f2f2259b9b69';
export default node;
